export default {
  setNpo(state, data) {
    state.user.loggedRole.npo = data
  },
  setDonation(state, data) {
    state.selectedDonation = data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/npos.js